import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveProjectAppById(context, projectId) {
      try {
        const structure = await axios.get(`/cfa-dynamo-data/projects-app/${projectId}`, { withCredentials: true });
        return structure.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
